module.exports = __webpack_public_path__ + "static/img/6.50cd34d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/6.png
// module id = Ncbf
// module chunks = 0